export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14398.f039d152.jpg";